<template>
  <div class="chat-widget-wrapper">
    <!-- Chat Button (Floating FAB) -->
    <button 
      class="chat-trigger-btn" 
      @click="toggleChat"
      v-if="!isOpen"
      title="Nhắn tin tư vấn"
    >
      <icon icon="fa-solid fa-comment-dots" class="trigger-icon" />
    </button>

    <!-- Chat Box Window -->
    <div v-if="isOpen" class="chat-box-card shadow">
      <!-- Header -->
      <div class="chat-box-header d-flex justify-content-between align-items-center px-3 py-2">
        <div class="d-flex align-items-center gap-2">
          <div class="header-avatar">
            <icon icon="fa-solid fa-user-tie" />
          </div>
          <div>
            <div class="header-name">Tư vấn viên Lối Đọc</div>
            <div class="header-status d-flex align-items-center">
              <span>Trực tuyến</span>
              <span class="quota-pill ms-2" :class="{ 'quota-warning': remaining <= 3, 'quota-out': remaining === 0 }">
                Còn {{ remaining }}/{{ maxLimit }} lượt/giờ
              </span>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center gap-1">
          <button class="action-btn" @click="toggleChat" title="Đóng">
            <icon icon="fa-solid fa-xmark" />
          </button>
        </div>
      </div>

      <!-- Messages Body -->
      <div class="chat-box-body p-3" ref="messagesContainer" @click="handleLinkClick">
        <!-- Welcome Message -->
        <div class="msg-group incoming">
          <div class="msg-avatar">
            <icon icon="fa-solid fa-user-tie" />
          </div>
          <div class="msg-bubble-wrap">
            <div class="msg-bubble">
              <p class="mb-1">Chào bạn! Bạn đang cần tìm kiếm sách hay muốn tư vấn gì về sách cứ nhắn cho mình nhé.</p>
              <p class="mb-0 text-muted" style="font-size: 0.76rem;">(Hệ thống hỗ trợ tối đa 10 lượt hỏi trong 1 giờ cho mỗi độc giả)</p>
            </div>
          </div>
        </div>

        <!-- Conversation Messages -->
        <div 
          v-for="(msg, index) in messages" 
          :key="index"
          class="msg-group"
          :class="msg.role === 'user' ? 'outgoing' : 'incoming'"
        >
          <div v-if="msg.role === 'model'" class="msg-avatar">
            <icon icon="fa-solid fa-user-tie" />
          </div>

          <div class="msg-bubble-wrap">
            <div 
              class="msg-bubble"
              v-html="formatMessage(msg.content)"
            ></div>
          </div>
        </div>

        <!-- Sending/Typing Indicator -->
        <div v-if="isLoading" class="msg-group incoming">
          <div class="msg-avatar">
            <icon icon="fa-solid fa-user-tie" />
          </div>
          <div class="msg-bubble-wrap">
            <div class="msg-bubble is-typing">
              <span class="typing-dot"></span>
              <span class="typing-dot"></span>
              <span class="typing-dot"></span>
            </div>
          </div>
        </div>
      </div>

      <!-- Input Footer -->
      <div class="chat-box-footer">
        <div v-if="remaining === 0" class="quota-warning-banner text-danger small mb-2 text-center">
          <icon icon="fa-solid fa-circle-exclamation" class="me-1" />
          Bạn đã dùng hết 10 lượt trong 1 giờ. Vui lòng quay lại sau.
        </div>
        <form @submit.prevent="sendMessage" class="input-form d-flex align-items-center">
          <textarea 
            class="input-control" 
            :placeholder="remaining > 0 ? 'Nhập tin nhắn...' : 'Đã hết lượt hỏi trong 1 giờ'" 
            v-model="newMessage"
            :disabled="remaining === 0"
            ref="messageInput"
            rows="1"
            @keydown.enter.exact.prevent="sendMessage"
            @input="autoResize"
          ></textarea>
          <button 
            type="submit" 
            class="send-btn" 
            :disabled="!newMessage.trim() || isLoading || remaining === 0"
            title="Gửi"
          >
            <icon icon="fa-solid fa-paper-plane" />
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script src="./ChatWidget.js"></script>
<style scoped src="./ChatWidget.css"></style>
